import React from 'react';

import { chartTypeEnum } from "../../../components/Graphs/GenericCategoryGraph";
import { TotalKitsMetadata } from "../../Dashboards/DashboardRPM";
import { getActiveMonthlyPillboxUsersMetadata } from "../../Dashboards/Widgets/EsiActivePillboxUsers";
import { getEsiPatientsStateMetadata } from "../../Dashboards/Widgets/EsiPatientStats";
import { PatientStatusMetadata } from "../../Dashboards/Widgets/PatientStatus";
import ReadingsWidget, { WidgetTypes } from "../../Dashboards/Widgets/ReadingsWidget";
import { customFormattingConfig, simpleChartTypeWithNumbersConfig, verticalChartTypeConfig } from "../../Dashboards/Widgets/WidgetConfigs";
import { PatientStatusInTimeMetadata } from '../../Dashboards/Widgets/PatientStatusInTime';
import { MetricsForTrendPlot, getMetricTrendMetadata } from '../../Dashboards/Widgets/MetricTrend';
import { getTrendAllIntervalsMetadata } from '../../Dashboards/Widgets/MetricTrendAllIntervals';
import { getStackedMetricTrendMetadata, MetricsForTrendPlotStacked } from '../../Dashboards/Widgets/StackedMetricTrend';
import { PatientsWithNoReadingsForXDaysMetadata } from '../../Dashboards/Widgets/PatientsWithNoReadingsForXDays';

//#region dashboard definitions
export const DASHBOARD_ID = 'ReportDashboard_3';

export const chartTypeConfig = {
  stackedChartType: {
    type: 'select',
    name: 'stackedChartType',
    label: 'Stacked Chart Type',
    defaultValue: chartTypeEnum.stackedPie,
    options: [
      { label: 'Stacked Bar chart', value: chartTypeEnum.stackedBar },
      { label: 'Stacked Horizontal Bar', value: chartTypeEnum.horizontalStackedBar },
      { label: 'Stacked Area chart', value: chartTypeEnum.stackedArea },
      { label: 'Stacked Pie chart', value: chartTypeEnum.stackedPie },
      { label: 'Line chart', value: chartTypeEnum.line },
    ],
    canBeSetByDashboard: false,
  },
};

export const EnrollmentsWithNoCptCodesRpmMetadata = {
  id: 'EnrollmentsWithNoCptCodesRpm',
  name: 'RPM - Enrollments with no CPT code',
  group: 'RPM',
  permission: '',
  defProps: { i: 'EnrollmentsWithNoCptCodesRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const EnrollmentsWithNoCptCodesRtmMetadata = {
  id: 'EnrollmentsWithNoCptCodesRtm',
  name: 'RTM - Enrollments with no CPT code',
  group: 'RTM',
  permission: '',
  defProps: { i: 'EnrollmentsWithNoCptCodesRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith20minCodeRtmMetadata = {
  id: 'PatientsWith20minCodeRtm',
  name: 'RTM - Enrollments with 20 min code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith20minCodeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith40minCodeRtmMetadata = {
  id: 'PatientsWith40minCodeRtm',
  name: 'RTM - Enrollments with 40 min code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith40minCodeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith60minCodeRtmMetadata = {
  id: 'PatientsWith60minCodeRtm',
  name: 'RTM - Enrollments with 60 min code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith60minCodeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith20minCodeRpmMetadata = {
  id: 'PatientsWith20minCodeRpm',
  name: 'RPM - Enrollments with 20 min code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith20minCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith40minCodeRpmMetadata = {
  id: 'PatientsWith40minCodeRpm',
  name: 'RPM - Enrollments with 40 min code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith40minCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWith60minCodeRpmMetadata = {
  id: 'PatientsWith60minCodeRpm',
  name: 'RPM - Enrollments with 60 min code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWith60minCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWoMonitoringCodeRtmRespMetadata = {
  id: 'PatientsWoMonitoringCodeRtmResp',
  name: 'RTM Resp - Enrollments with no monitoring code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRtmResp', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const PatientsWoMonitoringCodeRtmMsMetadata = {
  id: 'PatientsWoMonitoringCodeRtmMS',
  name: 'RTM Musc - Enrollments with no monitoring code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRtmMS', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const PatientsWoMonitoringCodeRtmBehavMetadata = {
  id: 'PatientsWoMonitoringCodeRtmBehav',
  name: 'RTM Bhv - Enrollments with no monitoring code',
  group: 'RTM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRtmBehav', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const PatientsWoMonitoringCodeRpmMetadata = {
  id: 'PatientsWoMonitoringCodeRpm',
  name: 'RPM - Enrollments with no monitoring code',
  group: 'RPM',
  permission: '',
  hiddenByDefault: true,
  defProps: { i: 'PatientsWoMonitoringCodeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const AvgEnrollmentTimeRpmMetadata = {
  id: 'AvgEnrollmentTimeRpm',
  name: 'RPM - Avg Enrollment Time',
  group: 'RPM',
  permission: '',
  defProps: { i: 'AvgEnrollmentTimeRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const AvgEnrollmentTimeRtmMetadata = {
  id: 'AvgEnrollmentTimeRtm',
  name: 'RTM - Avg Enrollment Time',
  group: 'RTM',
  permission: '',
  defProps: { i: 'AvgEnrollmentTimeRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const NewEnrollmentsRpmMetadata = {
  id: 'NewEnrollmentsRpm',
  name: 'RPM - New Enrollments',
  group: 'RPM',
  permission: '',
  defProps: { i: 'NewEnrollmentsRpm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};
export const NewEnrollmentsRtmMetadata = {
  id: 'NewEnrollmentsRtm',
  name: 'RTM - New Enrollments',
  group: 'RTM',
  permission: '',
  defProps: { i: 'NewEnrollmentsRtm', w: 4, h: 2, minW: 2, minH: 2 },
  configuration: customFormattingConfig,
};

export const AdherenceDistributionMetadata = {
  id: 'AdherenceDistribution',
  name: 'Adherence Distribution',
  permission: '',
  defProps: { i: 'AdherenceDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: verticalChartTypeConfig,
};

export const RTMNumberOfCptCodesMetadata = {
  id: 'RTMNumberOfCptCodes',
  group: 'RTM',
  name: 'RTM - number of CPT Codes',
  permission: '',
  defProps: { i: 'RTMNumberOfCptCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...simpleChartTypeWithNumbersConfig.chartType, defaultValue: chartTypeEnum.horizontalBar},
  },
};
export const RPMNumberOfCptCodesMetadata = {
  id: 'RPMNumberOfCptCodes',
  group: 'RPM',
  name: 'RPM - number of CPT Codes',
  permission: '',
  defProps: { i: 'RPMNumberOfCptCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {...simpleChartTypeWithNumbersConfig.chartType, defaultValue: chartTypeEnum.horizontalBar},
  },
};

export const RTMCptCodesDistributionMetadata = {
  id: 'RTMCptCodesDistribution',
  group: 'RTM',
  name: 'RTM - CPT Codes Distribution',
  permission: '',
  defProps: { i: 'RTMCptCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: simpleChartTypeWithNumbersConfig,
};
export const RPMCptCodesDistributionMetadata = {
  id: 'RPMCptCodesDistribution',
  group: 'RPM',
  name: 'RPM - CPT Codes Distribution',
  permission: '',
  defProps: { i: 'RPMCptCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: simpleChartTypeWithNumbersConfig,
};

export const RTMTimeCodesMetadata = {
  id: 'RTMTimeCodes',
  group: 'RTM',
  name: 'RTM - 20, 40, 60 Minutes Codes Distribution',
  permission: '',
  defProps: { i: 'RTMTimeCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: chartTypeConfig,
};
export const RPMTimeCodesMetadata = {
  group: 'RPM',
  id: 'RPMTimeCodes',
  name: 'RPM - 20, 40, 60 Minutes Codes Distribution',
  permission: '',
  defProps: { i: 'RPMTimeCodes', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: chartTypeConfig,
};
export const RTMMonitoringCodesDistributionMetadata = {
  group: 'RTM',
  id: 'RTMMonitoringCodesDistribution',
  name: 'RTM - Monitoring Codes Distribution',
  permission: '',
  defProps: { i: 'RTMMonitoringCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
  configuration: {
    chartType: {
      type: 'select',
      name: 'chartType',
      label: 'Chart Type',
      defaultValue: chartTypeEnum.hierarchicalPie,
      options: [
        { label: 'Stacked Bar chart', value: chartTypeEnum.stackedBar },
        { label: 'Stacked Area chart', value: chartTypeEnum.stackedArea },
        { label: 'Stacked Horizontal Bar', value: chartTypeEnum.horizontalStackedBar },
        { label: 'Hierarchical Pie chart', value: chartTypeEnum.hierarchicalPie },
      ],
      canBeSetByDashboard: false,
    },
  },
};
export const RPMMonitoringCodesDistributionMetadata = {
  id: 'RPMMonitoringCodesDistribution',
  group: 'RPM',
  name: 'RPM - Monitoring Codes Distribution',
  permission: '',
  defProps: { i: 'RPMMonitoringCodesDistribution', w: 4, h: 4, minW: 2, minH: 2 },
};

export const getWidgetMetadata = ({ skipPermissionCheck }) => Object.values(MetricsForTrendPlot).map(metric => ({ ...getMetricTrendMetadata(metric.id)}))
   .concat( Object.values(MetricsForTrendPlot).map(metric => ({ ...getTrendAllIntervalsMetadata(metric.id)})))
   .concat( Object.values(MetricsForTrendPlotStacked).map(metric => ({ ...getStackedMetricTrendMetadata(metric.id)})))
   .concat([
    PatientsWithNoReadingsForXDaysMetadata,
    // AdherenceDistributionMetadata,
    //PatientsPerProgramPerMonthMetadata,
 ]);
  //[
  // EnrollmentsWithNoCptCodesRpmMetadata,
  // EnrollmentsWithNoCptCodesRtmMetadata,
  // PatientsWith20minCodeRtmMetadata,
  // PatientsWith40minCodeRtmMetadata,
  // PatientsWith60minCodeRtmMetadata,
  // PatientsWoMonitoringCodeRtmRespMetadata,
  // PatientsWoMonitoringCodeRtmMsMetadata,
  // PatientsWoMonitoringCodeRtmBehavMetadata,
  // PatientsWith20minCodeRpmMetadata,
  // PatientsWith40minCodeRpmMetadata,
  // PatientsWith60minCodeRpmMetadata,
  // AvgEnrollmentTimeRpmMetadata,
  // AvgEnrollmentTimeRtmMetadata,
  // NewEnrollmentsRpmMetadata,
  // NewEnrollmentsRtmMetadata,
  // PatientsWoMonitoringCodeRpmMetadata,
  // RTMCptCodesDistributionMetadata,
  // RPMCptCodesDistributionMetadata,
  // RTMNumberOfCptCodesMetadata,
  // RPMNumberOfCptCodesMetadata,
  // RTMTimeCodesMetadata,
  // RPMTimeCodesMetadata,
  // RTMMonitoringCodesDistributionMetadata,
  // RPMMonitoringCodesDistributionMetadata,
  // PatientStatusMetadata,
  // PatientStatusInTimeMetadata,
  // TotalKitsMetadata,
  // TrendAllPeriodsMetadata,
  // {
  //   ...getActiveMonthlyPillboxUsersMetadata(skipPermissionCheck),
  //   group: 'Esi Patients',
  // },
  // {
  //   ...getEsiPatientsStateMetadata(skipPermissionCheck),
  //   group: 'Esi Patients',
  // },
//];

const getL = skipPermissionCheck => {
  const metricWidgets = Object.values(MetricsForTrendPlot).map((metric, i) => ({ ...getMetricTrendMetadata(metric.id).defProps, x: 4, y: 6 + i * 5, w: 4, h: 5 }));
  const trendWidgets = Object.values(MetricsForTrendPlot).map((metric, i) => ({ ...getTrendAllIntervalsMetadata(metric.id).defProps, x: 8, y: 6 + i * 5, w: 4, h: 5 }));
  const metricStackedWidgets = Object.values(MetricsForTrendPlotStacked).map((metric, i) => ({ ...getStackedMetricTrendMetadata(metric.id).defProps, x: 0, y: 16 + i * 5, w: 4, h: 5 }));
  return metricWidgets.concat(trendWidgets).concat(metricStackedWidgets)
    .concat([
      {...PatientsWithNoReadingsForXDaysMetadata.defProps, x: 0, y: 14, w: 4, h: 5 },
      // { ...AdherenceDistributionMetadata.defProps, x: 8, y: 6, w: 4, h: 6 },
      //{ ...PatientsPerProgramPerMonthMetadata.defProps, x: 4, y: 6, w: 4, h: 6 },
    ]);

  return [
    { ...EnrollmentsWithNoCptCodesRpmMetadata.defProps, x: 6, y: 20, w: 6, h: 2 },
    { ...EnrollmentsWithNoCptCodesRtmMetadata.defProps, x: 6, y: 12, w: 6, h: 2 },
    { ...AvgEnrollmentTimeRpmMetadata.defProps, x: 3, y: 20, w: 3, h: 2 },
    { ...AvgEnrollmentTimeRtmMetadata.defProps, x: 3, y: 12, w: 3, h: 2 },
    { ...NewEnrollmentsRpmMetadata.defProps, x: 0, y: 20, w: 3, h: 2 },
    { ...NewEnrollmentsRtmMetadata.defProps, x: 0, y: 12, w: 3, h: 2 },
    { ...RTMCptCodesDistributionMetadata.defProps, x: 3, y: 14, w: 3, h: 6 },
    { ...RPMCptCodesDistributionMetadata.defProps, x: 3, y: 22, w: 3, h: 6 },
    { ...RTMNumberOfCptCodesMetadata.defProps, x: 0, y: 14, w: 3, h: 6 },
    { ...RPMNumberOfCptCodesMetadata.defProps, x: 0, y: 22, w: 3, h: 6 },
    { ...RTMTimeCodesMetadata.defProps, x: 6, y: 14, w: 3, h: 6 },
    { ...RPMTimeCodesMetadata.defProps, x: 6, y: 22, w: 3, h: 6 },
    { ...RTMMonitoringCodesDistributionMetadata.defProps, x: 9, y: 14, w: 3, h: 6 },
    { ...RPMMonitoringCodesDistributionMetadata.defProps, x: 9, y: 22, w: 3, h: 6 },
    { ...PatientStatusMetadata.defProps, x: 0, y: 6, w: 4, h: 4 },
    { ...PatientStatusInTimeMetadata.defProps, x: 4, y: 6, w: 4, h: 4 },
    { ...TotalKitsMetadata.defProps, x: 0, y: 10, w: 4, h: 2 },
    { ...getActiveMonthlyPillboxUsersMetadata(skipPermissionCheck).defProps, x: 0, y: 28, w: 3, h: 2 },
    { ...getEsiPatientsStateMetadata(skipPermissionCheck).defProps, x: 3, y: 28, w: 4, h: 6 },
    { ...getTrendAllIntervalsMetadata.defProps, x: 0, y: 34, w: 4, h: 2 },
  ];
};

const getM = skipPermissionCheck => {
  const metricWidgets = Object.values(MetricsForTrendPlot).map((metric, i) => ({ ...getMetricTrendMetadata(metric.id).defProps, x: 0, y: 20 + i * 4, w: 4, h: 4 }));
  const trendWidgets = Object.values(MetricsForTrendPlot).map((metric, i) => ({ ...getTrendAllIntervalsMetadata(metric.id).defProps, x: 4, y: 20 + i * 4, w: 4, h: 4 }));
  const stackedWidgets = Object.values(MetricsForTrendPlotStacked).map((metric, i) => (
    { ...getStackedMetricTrendMetadata(metric.id).defProps, x: (i % 2) * 4, y: 5 * Math.floor((i + 2) / 2), w: 4, h: 5 }
  ));
  return metricWidgets.concat(trendWidgets).concat(stackedWidgets)
    .concat([
      {...PatientsWithNoReadingsForXDaysMetadata.defProps, x: 4, y: 14, w: 4, h: 5 },
      //{ ...1.defProps, x: 5, y: 5, w: 3, h: 6 },
      //{ ...PatientsPerProgramPerMonthMetadata.defProps, x: 2, y: 5, w: 3, h: 6 },
    ]);
  return [
    { ...EnrollmentsWithNoCptCodesRpmMetadata.defProps, x: 0, y: 11, w: 3, h: 2 },
    { ...EnrollmentsWithNoCptCodesRtmMetadata.defProps, x: 0, y: 23, w: 3, h: 2 },
    { ...AvgEnrollmentTimeRpmMetadata.defProps, x: 0, y: 13, w: 3, h: 2 },
    { ...AvgEnrollmentTimeRtmMetadata.defProps, x: 0, y: 27, w: 3, h: 2 },
    { ...NewEnrollmentsRpmMetadata.defProps, x: 0, y: 15, w: 3, h: 2 },
    { ...NewEnrollmentsRtmMetadata.defProps, x: 0, y: 25, w: 3, h: 2 },
    { ...RTMCptCodesDistributionMetadata.defProps, x: 0, y: 29, w: 4, h: 6 },
    { ...RPMCptCodesDistributionMetadata.defProps, x: 0, y: 17, w: 4, h: 6 },
    { ...RTMNumberOfCptCodesMetadata.defProps, x: 4, y: 29, w: 4, h: 6 },
    { ...RPMNumberOfCptCodesMetadata.defProps, x: 4, y: 17, w: 4, h: 6 },
    { ...RTMTimeCodesMetadata.defProps, x: 5, y: 23, w: 3, h: 6 },
    { ...RPMTimeCodesMetadata.defProps, x: 5, y: 11, w: 3, h: 6 },
    { ...RTMMonitoringCodesDistributionMetadata.defProps, x: 3, y: 23, w: 2, h: 6 },
    { ...RPMMonitoringCodesDistributionMetadata.defProps, x: 3, y: 11, w: 2, h: 6 },
    { ...PatientStatusMetadata.defProps, x: 0, y: 5, w: 2, h: 4 },
    { ...PatientStatusInTimeMetadata.defProps, x: 4, y: 5, w: 2, h: 4 },
    { ...TotalKitsMetadata.defProps, x: 0, y: 9, w: 2, h: 2 },
    { ...getActiveMonthlyPillboxUsersMetadata(skipPermissionCheck).defProps, x: 0, y: 35, w: 4, h: 2 },
    { ...getEsiPatientsStateMetadata(skipPermissionCheck).defProps, x: 4, y: 35, w: 4, h: 6 },
    { ...getMetricTrendMetadata.defProps, x: 0, y: 34, w: 4, h: 2 },
    { ...getTrendAllIntervalsMetadata.defProps, x: 0, y: 34, w: 4, h: 2 },
  ];
};

const getS = skipPermissionCheck => {
  const metricWidgets = Object.values(MetricsForTrendPlot).map((metric, i) => ({ ...getMetricTrendMetadata(metric.id).defProps, x: 0, y: 22 + i * 4, w: 2, h: 4 }));
  const trendWidgets = Object.values(MetricsForTrendPlot).map((metric, i) => ({ ...getTrendAllIntervalsMetadata(metric.id).defProps, x: 2, y: 22 + i * 4, w: 2, h: 4 }));
  const stackedWidgets = Object.values(MetricsForTrendPlotStacked).map((metric, i) => (
    { ...getStackedMetricTrendMetadata(metric.id).defProps, x: (i % 2) * 2, y: 6 + 4 * Math.floor((i + 2) / 2), w: 2, h: 4 }
  ));

  return metricWidgets.concat(trendWidgets).concat(stackedWidgets)
    .concat([
      {...PatientsWithNoReadingsForXDaysMetadata.defProps, x: 2, y: 14, w: 2, h: 4 },
      //{ ...AdherenceDistributionMetadata.defProps, x: 2, y: 14, w: 2, h: 6 },
      //{ ...PatientsPerProgramPerMonthMetadata.defProps, x: 0, y: 14, w: 2, h: 6 },
    ]);
  return [
    { ...EnrollmentsWithNoCptCodesRpmMetadata.defProps, x: 0, y: 20, w: 2, h: 2 },
    { ...EnrollmentsWithNoCptCodesRtmMetadata.defProps, x: 0, y: 37, w: 2, h: 2 },
    { ...AvgEnrollmentTimeRpmMetadata.defProps, x: 0, y: 22, w: 2, h: 2 },
    { ...AvgEnrollmentTimeRtmMetadata.defProps, x: 0, y: 39, w: 2, h: 2 },
    { ...NewEnrollmentsRpmMetadata.defProps, x: 0, y: 24, w: 2, h: 2 },
    { ...NewEnrollmentsRtmMetadata.defProps, x: 0, y: 41, w: 2, h: 2 },
    { ...RTMCptCodesDistributionMetadata.defProps, x: 2, y: 37, w: 2, h: 6 },
    { ...RPMCptCodesDistributionMetadata.defProps, x: 2, y: 20, w: 2, h: 6 },
    { ...RTMNumberOfCptCodesMetadata.defProps, x: 0, y: 43, w: 4, h: 5 },
    { ...RPMNumberOfCptCodesMetadata.defProps, x: 0, y: 26, w: 4, h: 5 },
    { ...RTMTimeCodesMetadata.defProps, x: 2, y: 48, w: 2, h: 6 },
    { ...RPMTimeCodesMetadata.defProps, x: 2, y: 31, w: 2, h: 6 },
    { ...RTMMonitoringCodesDistributionMetadata.defProps, x: 0, y: 48, w: 2, h: 6 },
    { ...RPMMonitoringCodesDistributionMetadata.defProps, x: 0, y: 31, w: 2, h: 6 },
    { ...PatientStatusMetadata.defProps, x: 0, y: 10, w: 2, h: 4 },
    { ...PatientStatusInTimeMetadata.defProps, x: 4, y: 5, w: 2, h: 4 },
    { ...TotalKitsMetadata.defProps, x: 2, y: 10, w: 2, h: 4 },
    { ...getActiveMonthlyPillboxUsersMetadata(skipPermissionCheck).defProps, x: 0, y: 54, w: 2, h: 2 },
    { ...getEsiPatientsStateMetadata(skipPermissionCheck).defProps, x: 2, y: 54, w: 2, h: 6 },
    { ...getMetricTrendMetadata.defProps, x: 0, y: 34, w: 4, h: 2 },
    { ...getTrendAllIntervalsMetadata.defProps, x: 0, y: 34, w: 4, h: 2 },
  ];
};

export const getDefaultLayouts = ({ skipPermissionCheck }) => {
  return { l: getL(skipPermissionCheck), m: getM(skipPermissionCheck), s: getS(skipPermissionCheck) };
};

export const numberWithTitleWidget = (
  meta,
  value,
  dashboardSettingsFeature = false,
  percent = undefined,
  unit = '',
) => {
  const displayValue = isNaN(value) ? '-' : `${value}${unit}${isNaN(percent) ? '' : ` (${percent}%)`}`;
  return {
    ...meta,
    configuration: dashboardSettingsFeature ? meta.configuration : undefined,
    noPadding: true,
    noBorder: true,
    render: (
      <ReadingsWidget
        color='#000'
        title={meta.name}
        value={displayValue}
        type={WidgetTypes.plain}
        // valueTooltip: PropTypes.string,
      />
    ),
  };
};

//#endregion
